export default "__VITE_ASSET__DSR0$IVG__"